/**
 * How a label pill behaves when its text is longer than the room it has - with `useFitText`, which
 * shrinks the font to fit.
 *
 * Sized to its text (`max-content`), a pill ran straight out of its table cell as soon as a
 * translation was longer than the English it was laid out for - "En attente de validation" in a
 * column cut for "Pending Hash". Capped at its container and kept on one line, it shrinks instead;
 * the ellipsis is only for what is still too long at the smallest size.
 */
export const pillFitSx = {
    display: 'inline-block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
} as const;

/**
 * The pill's shape below a desktop, as drawn on the design canvas.
 *
 * A table cell wants the small tight chip this has always been; a card does not. On a phone the pill
 * is what says whether a thing is on, paid or blocked while somebody scrolls past it, so it gets the
 * drawn shape - more room around the word, a softer corner, and a smaller, heavier word inside.
 *
 * Kept here because both pills compose it, and the shape drifting between them is exactly what the
 * canvas exists to stop.
 */
export const pillShapePhoneSx = {
    padding: '5px 10px',
    borderRadius: '8px',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: 1.3,
} as const;
